<template>
  <div id="app">
    <div class="mobile-topbar">
      <a class="logo" @click="goHome()">
        <img :src="staticUrl+'office/xzdzm/images/logo.png'">
      </a>
      <a class="mobile-topbar-a">登陆/注册会员</a>
    </div>
    <div class="mobile-main">
      <user-login/>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import { UserLogin } from '@/components'
export default {
  name: 'mobileLogin',
  components: {
    UserLogin,
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['isMobile','staticUrl']),
  },
  created () {
  },
  methods: {
    goHome () {
      this.$router.push({ name: 'home', query: {}})
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/mobile/index.scss';
  @import '@/assets/mobile/reservation.scss';
  @import "@/assets/mobile/home.scss";
</style>
